import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledReportEcommerceWrapper = styled.div`
    background-color: ${colorsPalettes.bluegrey[200]};
    display: flex;
    align-items: center;
    padding: 8px 16px;
    gap: 12px;
`;
